import React, { Component, Fragment } from "react";
import AuthorizedSendersModal from "../ModalPopups/AuthorizedSendersModal";
import MG_ConfirmationModal from "../ModalPopups/MG_ConfirmationModal";
import MG_EditEmailAliasModal from "../ModalPopups/MG_EditEmailAliasModal";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import EmailListMemType from "../Enums/EmailListMemType";
import MailGunMembersList from "../../Shared/MailGunMembersList";
import mailGunEmailActions from "../../../store/mailgunEmails/action";
import { connect } from "react-redux";
import { Card } from "react-bootstrap";
import _ from "lodash";

import { Form } from "react-bootstrap";
import axios from "../../Shared/auth-header";
import $ from "jquery";
import EmailConfigTeamsTable from "../TableData/EmailConfigTeamsTable";
import EmailConfigMemberTable from "../TableData/EmailConfigMemberTable";
import ConfigDataType from "../Enums/ConfigDataType";

import EmailService from "../EmailListService";
import MG_DeleteAllAuthSenders from "../ModalPopups/MG_DeleteAllAuthSenders";
import EmailConfigTables from "../Enums/EmailConfigTables";
import EmailConfigTabs from "../Enums/EmailConfigTabs";
import AddRecptType from "../Enums/AddRecptType";
import MG_Add_NonNatca from "../ModalPopups/MG_Add_NonNatca";
import MailGunEmailTypes from "../Enums/MailGunEmailTypes";
import MG_DeleteEmailList from "../ModalPopups/MG_DeleteEmailList";
import PermissionFeature from "../../Permissions/PermissionFeature";
import AuthService from "../../Auth/AuthService";
import RemoveActionType from "../Enums/RemoveActionType";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import chistory from "../../Shared/auth-header";

export class MailGunConfigurationTabs extends Component {
  constructor(props) {
    super(props);
    this.unsubscribersListRef = React.createRef();
    this.nonNatcaUnsubscribersListRef = React.createRef();
    this.additionalTeamUnsubscribersListRef = React.createRef();
    this.subscribersListRef = React.createRef();
    this.state = {
      isOpenAddNonNatcaModal: false,
      key: "subscribers",
      showEmailAliasModal: false,
      showEmailDeleteAllModal: false,
      showDeleteEmailListModal: false,
      userFirstName: "",
      userLastName: "",
      isConfirmModalOpen: false,

      emailPriviliges: [],
      selectedPrivilige: "readonly",
      reply_preference: "list",
      deleteEmailConfigRecordId: 0,

      teamModalOpended: false,
      memberModalOpended: false,
      deleteAuthSenderMemberId: 0,
      deleteAuthSenderTeamId: 0,
      removeActionType: 0,
      confirmModelType: 0,
      totalSyncMembers: 0,
      totalDupSyncMembers: 0,
    };
    this.confirmDeleteMember = () => {
      this.confirmed = async () => {
        ///Primary key of table is not 0
        let response = null;
        if (this.state.deleteEmailConfigRecordId !== 0) {
          if (
            this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Subscribers
          ) {
            // Means here we are dealing with *************Additional********** Subscribers => Members + Non Nacta
            if (this.state.deleteEmailConfigType == ConfigDataType.NonNatca) {
              let {
                mgListAddress,
                additionalRecipientsNonNatca,
              } = this.props.melstate;
              let { removeActionType } = this.state;
              let currentNonNatcaMember = additionalRecipientsNonNatca.find(
                (f) => f.address == this.state.nonNatcaMemberAddress
              );
              let apiRequestBody = {
                recipientType: AddRecptType.NonNatca,
                memberEmailAddress: currentNonNatcaMember.address,
                entityId: null,
                mailingListFullAddress: mgListAddress,
                teamMembers: null,
                removeActionType,
              };
              response = await EmailService.RemoveAddlRecipient(apiRequestBody);
              if (
                removeActionType == RemoveActionType.UnSubscribe &&
                response != null
              ) {
                const nonNatcaUnsubscribersList = this
                  .nonNatcaUnsubscribersListRef.current;
                nonNatcaUnsubscribersList.resetData();
                nonNatcaUnsubscribersList.reload();
              }
            } else {
              // Means Additional Members
              let {
                mgListAddress,
                additionalRecipientsMembers,
              } = this.props.melstate;
              let { removeActionType } = this.state;

              let currentMember = additionalRecipientsMembers.find(
                (f) => f.memberId == this.state.deleteEmailConfigRecordId
              );
              let apiRequestBody = {
                recipientType: AddRecptType.Member,
                memberEmailAddress: currentMember.address, /// member email address
                entityId: this.state.deleteEmailConfigRecordId, /// Member id to be deleted
                mailingListFullAddress: mgListAddress,
                teamMembers: null,
                removeActionType,
              };
              response = await EmailService.RemoveAddlRecipient(apiRequestBody);
              if (
                removeActionType == RemoveActionType.UnSubscribe &&
                response != null
              ) {
                const unsubscribersList = this.unsubscribersListRef.current;
                unsubscribersList.resetData();
                unsubscribersList.reload();
              }
            }
          }
          //Subscribers Tab Ends
          else if (
            this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Unsubscribed
          ) {
            if (this.state.deleteEmailConfigType == ConfigDataType.NonNatca) {
              const nonNatcaUnsubscribersListRef = this
                .nonNatcaUnsubscribersListRef.current;

              let { removeActionType, nonNatcaMemberAddress } = this.state;
              let currentNonNatcaMember = nonNatcaUnsubscribersListRef.state.nonNatcaUnSubscribers.find(
                (f) => f.address == nonNatcaMemberAddress
              );
              let apiRequestBody = {
                recipientType: AddRecptType.NonNatca,
                memberEmailAddress: currentNonNatcaMember.address,
                entityId: null,
                mailingListFullAddress: this.props.melstate.mgListAddress,
                teamMembers: null,
                removeActionType,
              };
              response = await EmailService.RemoveAddlRecipient(apiRequestBody);
              if (
                removeActionType == RemoveActionType.UnSubscribe &&
                response != null
              ) {
                nonNatcaUnsubscribersListRef.resetData();
                nonNatcaUnsubscribersListRef.reload();
              }
            }
          } else if (
            this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Settings
          ) {
            response = EmailService.RemoveAuthSender(
              this.state.deleteEmailConfigRecordId
            );
          }
        }

        /////////########END of Logic for DB Generated Removal Record###########/////////
        if (response != null) {
          if (
            this.props.melstate.currentEmailConfigTab ==
              EmailConfigTabs.Subscribers &&
            this.state.deleteEmailConfigType == ConfigDataType.NonNatca
          ) {
            this.props.removeSelectedNonNatcaMember(
              this.state.nonNatcaMemberAddress
            );
          } else if (
            this.props.melstate.currentEmailConfigTab ==
              EmailConfigTabs.Unsubscribed &&
            this.state.deleteEmailConfigType == ConfigDataType.NonNatca
          ) {
            let { nonNatcaMemberAddress } = this.state;

            const nonNatcaUnsubscribersListRef = this
              .nonNatcaUnsubscribersListRef.current;
            let afterRemoval = nonNatcaUnsubscribersListRef.state.nonNatcaUnSubscribers.filter(
              (f) => f.address != nonNatcaMemberAddress
            );

            nonNatcaUnsubscribersListRef.setState({
              nonNatcaUnSubscribers: afterRemoval,
            });
          } else {
            //For Removng Additional Members in Subscribers Tab
            this.deSelectMember(this.state.deleteAuthSenderMemberId); /// entity key id
            this.props.removeSelectedEntity(
              this.state.deleteAuthSenderMemberId,
              ConfigDataType.Member
            );
          }
        }
        ///########################Removed Record from UI(Client State)#############
        this.toggleConfirmDeleteModal();
      };
      return this;
    };

    this.confirmDeleteTeam = () => {
      this.confirmed = async () => {
        const { deleteEmailConfigRecordId } = this.state;
        let response = null;
        if (deleteEmailConfigRecordId !== 0) {
          if (
            this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Subscribers
          ) {
            //Remove Additional *Team* Subscriber from Mailing List
            let {
              mgListAddress,
              additionalRecipientsTeams,
            } = this.props.melstate;
            let { removeActionType } = this.state;
            let currentTeam = additionalRecipientsTeams.find(
              (f) => f.id == deleteEmailConfigRecordId
            );
            let apiRequestBody = {
              recipientType: AddRecptType.Team,
              memberEmailAddress: null,
              entityId: deleteEmailConfigRecordId, /// Can be Team id, now 'mail_gun_addtl_subs_teams's PrimaryKey.
              /// Member id to be deleted
              mailingListFullAddress: mgListAddress,
              teamMembers: currentTeam.members,
              removeActionType,
            };
            response = await EmailService.RemoveAddlRecipient(apiRequestBody);
            if (
              removeActionType == RemoveActionType.UnSubscribe &&
              response != null
            ) {
              const additionalTeamUnsubscribersListRef = this
                .additionalTeamUnsubscribersListRef.current;
              additionalTeamUnsubscribersListRef.resetData();
              additionalTeamUnsubscribersListRef.reload();
            }
          }
          //#################  END of Delete Work for (Team Additional **Subscribers***) Tab data ###################
          else if (
            this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Settings
          ) {
            response = EmailService.RemoveAuthSender(deleteEmailConfigRecordId);
          }

          //Removing Additional Unsubscribed Team Members
          else if (
            this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Unsubscribed
          ) {
            const additionalTeamUnsubscribersListRef = this
              .additionalTeamUnsubscribersListRef.current;

            let { removeActionType } = this.state;
            let currentTeam = additionalTeamUnsubscribersListRef.state.additionalTeamUnSubscribers.find(
              (f) => f.id == deleteEmailConfigRecordId
            );
            let apiRequestBody = {
              recipientType: AddRecptType.Team,
              memberEmailAddress: null,
              entityId: deleteEmailConfigRecordId, /// Can be Team id, now 'mail_gun_addtl_subs_teams's PrimaryKey.
              /// Member id to be deleted
              mailingListFullAddress: this.props.melstate.mgListAddress,
              teamMembers: currentTeam.members,
              removeActionType,
            };
            response = await EmailService.RemoveAddlRecipient(apiRequestBody);
            if (response != null) {
              additionalTeamUnsubscribersListRef.resetData();
              additionalTeamUnsubscribersListRef.reload();
            }
          }
        } // Means new Team, delete it from client side??????
        if (
          response != null &&
          (this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Settings ||
            this.props.melstate.currentEmailConfigTab ==
              EmailConfigTabs.Subscribers)
        ) {
          //Could be Subscriber's Tab Team or Settings's Tab Authorized Team
          this.deSelectTeam(this.state.deleteAuthSenderTeamId);
          this.props.removeSelectedEntity(
            this.state.deleteAuthSenderTeamId,
            ConfigDataType.Team
          );
        }
        if (
          response != null &&
          this.props.melstate.currentEmailConfigTab ==
            EmailConfigTabs.Subscribers
        ) {
          //Subscribers Tab Team
          this.props.reloadAdditionalSubsriberTeams();
        }
        ///########################Removed Record from UI(Client State)#############

        this.toggleConfirmDeleteModal();
      };
      return this;
    };
    this.confirmDeleteAll = () => {
      this.confirmed = () => {
        const { currentEmailConfigTab } = this.props.melstate;
        if (currentEmailConfigTab == EmailConfigTabs.Subscribers) {
          this.props.deleteAllAddlListClick(
            this.props.melstate.emailListId,
            this.props.melstate.emailEntityType
          );
        } else if (currentEmailConfigTab == EmailConfigTabs.Settings) {
          this.props.deleteAllAuthorizedListClick(
            this.props.melstate.emailListId,
            this.props.melstate.emailEntityType
          );
        }
        this.toggleDeleteAllModal();
      };

      return this;
    };
    this.confirmEmailList = () => {
      this.confirmed = async () => {
        let { emailListId, emailEntityType } = this.props.melstate;
        let deleteResponse = null;
        if (emailEntityType == MailGunEmailTypes.Member) {
          await EmailService.DeleteSSEmailList(emailListId).then(
            ({ data: response }) => {
              $(".loading").hide();
              if (response.status === "success") {
                toast.success("Email list removed successfully!");
                deleteResponse = 1;
                $(".loading").hide();
              } else {
                toast.error(response.message);
                deleteResponse = 0;
                $(".loading").hide();
              }
            }
          );
        } else if (emailEntityType !== MailGunEmailTypes.Member) {
          await EmailService.DeleteFRTEmailList(emailListId).then(
            ({ data: response }) => {
              $(".loading").hide();
              if (response.status === "success") {
                toast.success("Email list removed successfully!");
                deleteResponse = 1;
                $(".loading").hide();
              } else {
                toast.error(response.message);
                deleteResponse = 0;
                $(".loading").hide();
              }
            }
          );
        }
        this.toggleDeleteEmailListModal();
        if (deleteResponse == 1) {
          chistory.push("/admin/email-list");
        }
      };

      return this;
    };
  }

  componentDidMount = async () => {
    this.fetchPrivileges();
    await this.getSavedAccessLevel();
    let activeTabKey = !this.props.ssUpdateEmailListMode
      ? "settings"
      : "subscribers";
    this.setState({ key: activeTabKey });
    var address = this.props.mgListAddress;
    if (address && this.props.emailListExists) {
      EmailService.GetMailingListMemberCount(address)
        .then(({ data: response }) => {
          if (response.status === "success") {
            this.setState({
              totalSyncMembers: response.data.totalCount,
              totalDupSyncMembers: response.data.dupCount,
            });
          }
        })
        .catch((ex) => {
          console.log(ex);
          toast.error("Something went wrong!");
        });
    }
  };
  getSavedAccessLevel = async () => {
    //entity key passed from ConfigureMG_Email

    let { emailEntityType, entityKey } = this.props;
    ///debugger;
    if (entityKey)
      if (emailEntityType !== MailGunEmailTypes.Member) {
        if (emailEntityType) {
          let url = `/api/FacilityRegionEmail/GetEmailPrivilege?entityKey=${entityKey}&entityType=${emailEntityType}`;
          await axios.get(url).then(({ data: response }) => {
            if (response.status === "success") {
              this.setState({
                selectedPrivilige: response.access_Level,
                reply_preference: response.reply_preference,
                email_alias: response.email_alias, //`facility_region_email_list`.`email_alias`
                name: response.name, //`facility_region_email_list`.`email_list_title`
              });
              this.props.setReplyPref(response.reply_preference);
              this.props.setPrivilege(response.access_Level);
              this.props.setEmailListName(response.name);
            }
          });
        }
      } else if (emailEntityType == MailGunEmailTypes.Member) {
        /// Saved Search Email List
        await EmailService.GetSavedSearchDetail(entityKey)
          .then(({ data: response }) => {
            if (response.status === "success") {
              this.setState({
                entityKey: response.searchDetail.saved_search_id,
                mailingListAddress: response.searchDetail.email_address,
                email_list_title: response.searchDetail.email_list_title,
                emailListId: response.searchDetail.id,
                emailEntityType: MailGunEmailTypes.Member,
                reply_preference: response.searchDetail.reply_preference,
                selectedPrivilige: response.selectedPrivilege,
              });
              this.props.setReplyPref(response.searchDetail.reply_preference);
              this.props.setPrivilege(response.selectedPrivilege);
              this.props.setEmailListName(
                response.searchDetail.email_list_title
              );
              /// console.log(this.state.mailingListAddress);
            }
          })
          .catch((ex) => {
            console.log(ex);
            toast.error("Something went wrong!");
          });
      }
  };
  fetchPrivileges = () => {
    axios
      .get("/api/SavedSearchEmailList/GetEmailPriviliges")
      .then(({ data: res }) => {
        this.hideSpinner();
        this.setState({
          emailPriviliges: res,
        });
      });
  };

  onPrivilegeChange = (e) => {
    let { selectedPrivilige } = this.props.melstate;
    this.setState({
      selectedPrivilige: e.currentTarget.value,
    });
    this.props.setPrivilege(e.currentTarget.value);
    let alreadyAuthSender =
      this.props.melstate.authorizedSendersRows &&
      this.props.melstate.authorizedSendersRows.length > 0;
    if (alreadyAuthSender && selectedPrivilige == "readonly") {
      this.toggleDeleteAllModal();
    }
  };
  handleChange = (evt) => {
    this.setState({
      [evt.target.id]: evt.target.value,
    });
    if (evt.target.id == "reply_preference") {
      this.props.setReplyPref(evt.target.value);
    }

    if (evt.target.id == "emailAlias") {
      let val = evt.target.value.replace(/[^\w\s-]/gi, "");
      this.props.setMgListAlias(val);
    }
  };
  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };
  setKey = async (k) => {
    this.setState({ key: k });
    await this.props.setCurrentEmailConfigTab(k);
  };
  renderEmailPriviliges = (isDisabled) => {
    const { emailPriviliges } = this.state;
    if (!emailPriviliges) return;
    return (
      <div className="row">
        {emailPriviliges.map((privilege, idx) => {
          return (
            <div class="col-md-3" key={idx}>
              <Form.Check
                custom
                type="radio"
                label={privilege.privilage_name}
                checked={
                  privilege.api_value === this.props.melstate.selectedPrivilige
                }
                id={privilege.api_value}
                name="emailPrivilige[]"
                value={privilege.api_value}
                disabled={!isDisabled}
                onChange={this.onPrivilegeChange}
              />
            </div>
          );
        })}
      </div>
    );
  };
  ///Invoked before Opening "Confirm Delete Member" Modal
  handleConfirmDeleteMember = (id, memberid, type, removeActionType) => {
    if (id !== 0) {
      this.setState(
        {
          isConfirmModalOpen: !this.state.isConfirmModalOpen,
        },
        () => {
          if (type == EmailConfigTables.NonNatcaMembers) {
            this.setState({
              deleteEmailConfigRecordId: memberid,
              nonNatcaMemberAddress: memberid, ///this will be the string address of member
              deleteEmailConfigType: ConfigDataType.NonNatca,
              confirmModelType: type,
              removeActionType,
            });
          } else {
            this.setState({
              deleteEmailConfigRecordId: id, // row.id can be zero
              deleteAuthSenderMemberId: memberid, /// int id of the member
              deleteEmailConfigType: ConfigDataType.Member,
              confirmModelType: type,
              removeActionType,
            });
          }
        }
      );
    } else {
      if (type == EmailConfigTables.NonNatcaMembers) {
        this.props.removeSelectedNonNatcaMember(memberid);
      } else {
        this.props.removeSelectedEntity(memberid, ConfigDataType.Member);
        this.deSelectMember(memberid);
      }
    }
  };
  // Non Natca Member
  // handleConfirmDeleteNonNatcaMember = (id, address) => {
  //   if (id !== 0) {
  //     this.setState(
  //       {
  //         isConfirmModalOpen: !this.state.isConfirmModalOpen,
  //       },
  //       () => {
  //         this.setState({
  //           deleteEmailConfigRecordId: address,
  //           nonNatcaMemberAddress: address,
  //           deleteEmailConfigType: ConfigDataType.NonNatca,
  //         });
  //       }
  //     );
  //   } else {
  //     this.props.removeSelectedNonNatcaMember(address);
  //     //this.deSelectMember(address);
  //   }
  // };
  handleConfirmDeleteTeam = (id, teamid, type, removeActionType) => {
    if (id) {
      this.setState(
        {
          isConfirmModalOpen: !this.state.isConfirmModalOpen,
        },
        () => {
          this.setState({
            deleteEmailConfigRecordId: id,
            deleteAuthSenderTeamId: teamid,
            deleteEmailConfigType: ConfigDataType.Team,
            confirmModelType: type,
            removeActionType,
          });
        }
      );
    } else {
      this.props.removeSelectedEntity(teamid, ConfigDataType.Team);
      this.deSelectTeam(teamid);
    }
  };

  toggleConfirmDeleteModal = (id) => {
    this.setState({
      isConfirmModalOpen: !this.state.isConfirmModalOpen,
    });
  };
  setCurrentTeamInfo = (teamName, teamid, removeActionType) => {
    this.setState({
      team: teamName,
      teamId: teamid,
      teamModalOpended: true,
      memberModalOpended: false,
      removeActionType,
    });
  };
  setCurrentSenderInfo = (firstname, lastname, memberid, removeActionType) => {
    this.setState({
      userFirstName: firstname,
      userLastName: lastname,
      memberId: memberid,
      memberModalOpended: true,
      teamModalOpended: false,
      removeActionType,
    });
  };
  toggleEmailAliasModal = () => {
    this.setState({
      showEmailAliasModal: !this.state.showEmailAliasModal,
    });
  };
  toggleDeleteAllModal = () => {
    this.setState({
      showEmailDeleteAllModal: !this.state.showEmailDeleteAllModal,
    });
  };
  onCancelClick = () => {
    this.toggleDeleteAllModal();
    this.setState({ selectedPrivilige: "readonly" });
    this.props.setPrivilege("readonly");
  };
  toggleDeleteEmailListModal = () => {
    this.setState({
      showDeleteEmailListModal: !this.state.showDeleteEmailListModal,
    });
  };
  deSelectMember = (id) => {
    this.props.deSelectMember(id);
  };
  selectMember = (selectedMem) => {
    this.props.selectMember(selectedMem);
  };
  deSelectTeam = (id) => {
    this.props.deSelectTeam(id);
  };
  selectTeam = (selectedTeam) => {
    this.props.selectTeam(selectedTeam);
  };
  addAuthTeams = () => {
    this.props.selectMultipleAuthSender(
      this.state.selectedTeams,
      ConfigDataType.Team
    );
    this.handleClose();
  };
  addAuthMembers = () => {
    this.props.selectMultipleAuthSender(ConfigDataType.Member);
    this.handleClose();
  };
  changeHandlerListName = (evt) => {
    this.props.setEmailListName(evt.target.value);
  };
  toggleAddNonNatcaModal = () => {
    this.setState({
      isOpenAddNonNatcaModal: !this.state.isOpenAddNonNatcaModal,
    });
  };
  emailConfigFacilityHeader = (title, entityKey) => {
    return (
      <>
        <Link
          className="emailConfigHeader font-italic pr-1"
          to={{
            pathname: "/directory/facility/view/" + entityKey,
          }}
        >
          {title}
        </Link>
      </>
    );
  };
  emailConfigTeamHeader = (title, entityKey) => {
    return (
      <>
        <Link
          to={`/permissions/teams/teamDetail/${entityKey}`}
          class="emailConfigHeader font-italic pr-1"
        >
          {title}
        </Link>
      </>
    );
  };
  emailConfigHeaderSaveSearch = (title, entityKey) => {
    return (
      <>
        <span class="emailConfigHeader emailConfigHeaderHightLight font-italic pr-1">
          {title}
        </span>
      </>
    );
  };
  emailConfigHeaderArea = (title, entityKey) => {
    return (
      <>
        <span class="emailConfigHeader emailConfigHeaderHightLight font-italic pr-1 ">
          {title}
        </span>
      </>
    );
  };
  emailConfigHeaderRegion = (title, entityKey) => {
    return (
      <>
        <span class="emailConfigHeader emailConfigHeaderHightLight font-italic pr-1">
          {title}
        </span>
      </>
    );
  };
  emailConfigHeaderRegis = (title) => {
    return (
      <>
        <Link
          className="emailConfigHeader font-italic pr-1"
          to={{
            pathname: "/Registrations",
          }}
        >
          {title}
        </Link>
      </>
    );
  };
  render() {
    const {
      currentEmailConfigTab,
      additionalRecipientsRows,
      authorizedSendersRows,
      emailEntityType,
      entityKey,
    } = this.props.melstate;
    let deletBtnText = "";
    let header;
    if (currentEmailConfigTab == EmailConfigTabs.Subscribers) {
      deletBtnText = "Delete All Additional Subscribers";
    } else if (currentEmailConfigTab == EmailConfigTabs.Settings) {
      deletBtnText = "Delete All Authorized Senders";
    }
    let showDeleteBtn =
      currentEmailConfigTab == EmailConfigTabs.Subscribers ||
      currentEmailConfigTab == EmailConfigTabs.Settings;
    let anyDataInTbls = false;
    if (currentEmailConfigTab == EmailConfigTabs.Subscribers) {
      anyDataInTbls = additionalRecipientsRows.length > 0;
    } else if (currentEmailConfigTab == EmailConfigTabs.Settings) {
      anyDataInTbls = authorizedSendersRows.length > 0;
    }
    if (emailEntityType == MailGunEmailTypes.Team) {
      header = this.emailConfigTeamHeader("Teams", entityKey);
    } else if (emailEntityType == MailGunEmailTypes.Member) {
      header = this.emailConfigHeaderSaveSearch("Saved Search");
    } else if (emailEntityType == MailGunEmailTypes.Area) {
      header = this.emailConfigHeaderArea("Area");
    } else if (emailEntityType == MailGunEmailTypes.Region) {
      header = this.emailConfigHeaderRegion("Region");
    } else if (emailEntityType == MailGunEmailTypes.Facility) {
      header = this.emailConfigFacilityHeader("Facility", entityKey);
    } else if (emailEntityType == MailGunEmailTypes.Registrants) {
      header = this.emailConfigHeaderRegis("Registrations");
    }
    return (
      <>
        {!this.props.isModalPopUpOpended && (
          <>
            <h3>{`${this.props.emailListTitle}`}</h3>
            <span className="hidden">Total:{this.state.totalSyncMembers}</span>
            <span className="hidden">
              Duplicates:{this.state.totalDupSyncMembers}
            </span>

            <div className="mainHeaderLine">
              <h6>{header}</h6>
              <span>|</span>

              {this.props.emailListTitle ? (
                <h6 className="emailConfigHeader emailConfigHeaderHightLight font-italic pl-1 pr-1">
                  {this.props.emailListTitle.replace("Email List", "")}
                </h6>
              ) : (
                ""
              )}

              {this.props.emailListTitle ? <span>|</span> : ""}
              <h6 className="emailConfigHeader font-italic pl-1">
                Configure Email List
              </h6>
            </div>
          </>
        )}

        <Tabs
          id="emailConfigTabs"
          activeKey={this.state.key}
          onSelect={(k) => this.setKey(k)}
          className="mb-3"
        >
          {/* ************ Add Mode ************** */}
          {/* Email List does not Exists */}
          {/* {this.props.emailListExists && ( */}

          <Tab
            eventKey="subscribers"
            tabClassName={!this.props.ssUpdateEmailListMode ? "d-none" : ""}
            title={
              <>
                <i class="fas fa-users">
                  {" "}
                  <span className="font-weight-bold"> Subscribers</span>
                </i>
              </>
            }
          >
            {this.props.emailListExists && (
              <>
                <MailGunMembersList
                  mgListAddress={this.props.mgListAddress}
                  emailListMemType={EmailListMemType.Subscribers}
                  ref={this.subscribersListRef}
                  hideActionColumn={this.props.hideActionIcons}
                />

                {/*################# Additional Recipients Work in Subscribers Tab################# */}
                {AuthService.canView(
                  PermissionFeature.EmailAddlSubscribersList
                ) && (
                  <>
                    <h4 className="text-center">
                      Additional Recipients{" "}
                      <i
                        className="fa fa-refresh c-pointer"
                        aria-hidden="true"
                        title="Refresh"
                        onClick={async () => {
                          await this.props.setAddtlSubsLoading(true);
                          await this.props.reloadAdditionalSubsribersTables();
                          await this.props.setAddtlSubsLoading(false);
                        }}
                      />
                    </h4>

                    <div className="row pl-2 pr-2">
                      <div className="col-12">
                        {this.props.hideActionIcons && (
                          <div className="row">
                            <div className="col-md-6 col-sm-12">
                              {!this.props.melstate
                                .isLoadingAdditionalSubscriber &&
                                this.subscribersListRef &&
                                this.subscribersListRef.current &&
                                !this.subscribersListRef.current.state
                                  .loadingSubs && (
                                  <h5 className="cursorPointer">
                                    {/* Additional Recipients{" "} */}
                                    Add Members/Teams{" "}
                                    <i
                                      className="fa fa-plus-circle text-success"
                                      // ref={(el) => {
                                      //   if (el) {
                                      //     this.props.melstate
                                      //       .isLoadingAdditionalSubscriber &&
                                      //       el.style.setProperty(
                                      //         "cursor",
                                      //         "not-allowed",
                                      //         "important"
                                      //       );

                                      //     !this.props.melstate
                                      //       .isLoadingAdditionalSubscriber &&
                                      //       el.style.setProperty(
                                      //         "cursor",
                                      //         "default",
                                      //         "important"
                                      //       );
                                      //   }
                                      // }}
                                      onClick={() =>
                                        !this.props.melstate
                                          .isLoadingAdditionalSubscriber &&
                                        this.props.toggleSelectAddRecptModal()
                                      }
                                    />
                                  </h5>
                                )}
                            </div>
                            {showDeleteBtn && anyDataInTbls && (
                              <div className="col-md-6 col-sm-12 align-self-center">
                                <div className="float-right">
                                  <button
                                    type="button"
                                    onClick={this.toggleDeleteAllModal}
                                    class="btn btn-outline-danger"
                                  >
                                    {deletBtnText}
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* <h5 className="mb-1">Additional MEMBERS</h5> */}
                        <EmailConfigMemberTable
                          listData={
                            this.props.melstate.additionalRecipientsMembers
                          }
                          loading={
                            this.props.melstate.isLoadingAdditionalSubscriber
                          }
                          confirmDeleteMember={this.handleConfirmDeleteMember}
                          toggleConfirm={this.toggleConfirmDeleteModal}
                          setCurrentSenderInfo={this.setCurrentSenderInfo}
                          keyIdfr={EmailConfigTables.AdditionalRecipientsMember}
                          caption={"MEMBERS"}
                          hideActionColumn={this.props.hideActionIcons}
                        />
                        {/* <h5 className="mb-1">Additional TEAMS</h5> */}
                        <div className="pt-2">
                          <EmailConfigTeamsTable
                            listData={
                              this.props.melstate.additionalRecipientsTeams
                            }
                            loading={
                              this.props.melstate.isLoadingAdditionalSubscriber
                            }
                            confirmDeleteTeam={this.handleConfirmDeleteTeam}
                            toggleConfirm={this.toggleConfirmDeleteModal}
                            setCurrentTeamInfo={this.setCurrentTeamInfo}
                            keyIdfr={EmailConfigTables.AdditionalRecipientsTeam}
                            caption={"TEAMS"}
                            hideActionColumn={this.props.hideActionIcons}
                          />
                        </div>
                        <div className="pt-2">
                          {this.props.hideActionIcons && (
                            <h5 className="cursorPointer">
                              Add Non-NATCA{" "}
                              <i
                                className="fa fa-plus-circle text-success"
                                onClick={() => this.toggleAddNonNatcaModal()}
                              />
                            </h5>
                          )}
                          {/* <h5 className="mb-1">Additional NonNatca Members</h5> */}
                          <EmailConfigMemberTable
                            listData={
                              this.props.melstate.additionalRecipientsNonNatca
                            }
                            loading={
                              this.props.melstate.isLoadingAdditionalSubscriber
                            }
                            confirmDeleteMember={this.handleConfirmDeleteMember}
                            toggleConfirm={this.toggleConfirmDeleteModal}
                            setCurrentSenderInfo={this.setCurrentSenderInfo}
                            keyIdfr={EmailConfigTables.NonNatcaMembers}
                            caption={"NON-NATCA"}
                            hideActionColumn={this.props.hideActionIcons}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {/* ########################### END Additional Subscribers Tables############################# */}
          </Tab>

          <Tab
            tabClassName={!this.props.ssUpdateEmailListMode ? "d-none" : ""}
            eventKey="unsubscribed"
            title={
              <>
                <i className="fas fa-user-slash">
                  <span className="font-weight-bold"> Unsubscribed</span>
                </i>
              </>
            }
          >
            <MailGunMembersList
              mgListAddress={this.props.mgListAddress}
              emailListMemType={EmailListMemType.UnSubscribers}
              ref={this.unsubscribersListRef}
              unSubscribersListRef={this.unsubscribersListRef}
              nonNatcaUnsubscribersListRef={this.nonNatcaUnsubscribersListRef}
              subscribersListRef={this.subscribersListRef}
              additionalTeamUnsubscribersListRef={
                this.additionalTeamUnsubscribersListRef
              }
              hideActionColumn={this.props.hideActionIcons}
            />

            <MailGunMembersList
              mgListAddress={this.props.mgListAddress}
              emailListMemType={EmailListMemType.NonNatcaUnSubscribers}
              ref={this.nonNatcaUnsubscribersListRef}
              subscribersListRef={this.subscribersListRef}
              unSubscribersListRef={this.unsubscribersListRef}
              nonNatcaUnsubscribersListRef={this.nonNatcaUnsubscribersListRef}
              additionalTeamUnsubscribersListRef={
                this.additionalTeamUnsubscribersListRef
              }
              setCurrentSenderInfo={this.setCurrentSenderInfo}
              confirmDeleteMember={this.handleConfirmDeleteMember}
              keyIdfr={EmailConfigTables.NonNatcaMembers}
              hideActionColumn={this.props.hideActionIcons}
            />
            {/* New Table for Team Unsubscribers */}
            <MailGunMembersList
              mgListAddress={this.props.mgListAddress}
              emailListMemType={EmailListMemType.AdditionalTeamUnSubscribers}
              ref={this.additionalTeamUnsubscribersListRef}
              subscribersListRef={this.subscribersListRef}
              unSubscribersListRef={this.unsubscribersListRef}
              nonNatcaUnsubscribersListRef={this.nonNatcaUnsubscribersListRef}
              additionalTeamUnsubscribersListRef={
                this.additionalTeamUnsubscribersListRef
              }
              isTeamsTable={true}
              //Deletion from Additional Team Unsubscribers
              confirmDeleteTeam={this.handleConfirmDeleteTeam}
              toggleConfirm={this.toggleConfirmDeleteModal}
              setCurrentTeamInfo={this.setCurrentTeamInfo}
              keyIdfr={EmailConfigTables.AdditionalRecipientsTeam}
              hideActionColumn={this.props.hideActionIcons}
            />
          </Tab>

          {/* )} */}
          {/*####################### Main Configuration (Settings)Tab with Authorized Senders Work########################## */}
          <Tab
            eventKey="settings"
            title={
              <>
                <i className="fas fa-users-cog">
                  <span className="font-weight-bold"> Settings</span>
                </i>
              </>
            }
            tabClassName=""
          >
            <Card>
              <Card.Body className="pt-0">
                {
                  <Fragment>
                    <div className="row">
                      <div className="col">
                        <h4>Email List Details</h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6 col-md-3 font-weight-bold">
                        <h6>List Address</h6>
                      </div>
                      <div className="col-sm-6 col-md-9 pt-2">
                        <span class="font-weight-bold">
                          {this.props.melstate.mgListAddressAlias}
                        </span>
                        <span>@{this.props.melstate.mgListDomain}</span>{" "}
                        <i
                          className="fas fa-edit cursorPointer"
                          onClick={
                            !this.props.hideActionIcons
                              ? null
                              : this.toggleEmailAliasModal
                          }
                        />
                      </div>
                    </div>
                    {/* {AuthService.canView(
                      PermissionFeature.EmailAuthSendersList
                    ) && (
                      <div className="row">
                        <div className="col-sm-6 col-md-3 font-weight-bold">
                          <h6>Post Address</h6>
                        </div>
                        <div className="col-sm-6 col-md-9 pt-2">
                          <span class="font-weight-bold">
                            {this.props.melstate.mgListAddressAlias}
                          </span>
                          <span>{this.props.melstate.postListDomain}</span>{" "}
                        </div>
                      </div>
                    )} */}

                    <p className="mt-3">Who can send to list?</p>
                    <div className="row">
                      <div className="col-md-12">
                        {this.renderEmailPriviliges(this.props.hideActionIcons)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p className="mt-3">Reply Preference?</p>
                        <select
                          className="browser-default custom-select"
                          id="reply_preference"
                          onChange={this.handleChange}
                          defaultValue={
                            this.props.melstate.replyPreference || "list"
                          }
                          disabled={!this.props.hideActionIcons}
                          value={this.props.melstate.replyPreference}
                        >
                          <option
                            value="list"
                            // selected={
                            //   this.props.melstate.replyPreference === "list"
                            // }
                          >
                            List
                          </option>
                          <option
                            value="sender"
                            // selected={
                            //   this.props.melstate.replyPreference === "sender"
                            // }
                          >
                            Sender
                          </option>
                        </select>
                      </div>
                    </div>

                    {AuthService.canView(
                      PermissionFeature.EmailAuthSendersList
                    ) &&
                      this.props.melstate.selectedPrivilige == "readonly" && (
                        <div className="row mt-3">
                          <div className="col-12">
                            {/* //Action buttons div// */}
                            {this.props.hideActionIcons && (
                              <div className="row">
                                <div className="col-md-6 col-sm-12">
                                  {((!this.props.melstate
                                    .isLoadingAdditionalSubscriber &&
                                    this.subscribersListRef &&
                                    !this.props.melstate
                                      .isLoadingAuthorizedSenders &&
                                    this.subscribersListRef.current &&
                                    !this.subscribersListRef.current.state
                                      .loadingSubs) ||
                                    !this.props.emailListExists) && (
                                    <h4 className="cursorPointer">
                                      Authorized Senders{" "}
                                      <i
                                        className="fa fa-plus-circle text-success"
                                        onClick={() =>
                                          this.props.toggleSelectAuthSendersModal()
                                        }
                                      />
                                    </h4>
                                  )}
                                </div>
                                {showDeleteBtn && anyDataInTbls && (
                                  <div className="col-md-6 col-sm-12 align-self-center">
                                    <div className="float-right">
                                      <button
                                        type="button"
                                        onClick={this.toggleDeleteAllModal}
                                        class="btn btn-outline-danger"
                                      >
                                        {deletBtnText}
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            {/*########################### Authorized Senders Tables############ */}
                            {/* <h5 className="mb-1">Members</h5> */}
                            <EmailConfigMemberTable
                              listData={
                                this.props.melstate.authorizedSendersMembers
                              }
                              loading={
                                this.props.melstate.isLoadingAuthorizedSenders
                              }
                              confirmDeleteMember={
                                this.handleConfirmDeleteMember
                              }
                              toggleConfirm={this.toggleConfirmDeleteModal}
                              setCurrentSenderInfo={this.setCurrentSenderInfo}
                              keyIdfr={
                                EmailConfigTables.AuthorizedSendersMember
                              }
                              caption={"MEMBERS"}
                              hideActionColumn={this.props.hideActionIcons}
                            />
                            {/* <h5 className="mb-1">Teams</h5> */}
                            <EmailConfigTeamsTable
                              listData={
                                this.props.melstate.authorizedSendersTeams
                              }
                              loading={
                                this.props.melstate.isLoadingAuthorizedSenders
                              }
                              confirmDeleteTeam={this.handleConfirmDeleteTeam}
                              toggleConfirm={this.toggleConfirmDeleteModal}
                              setCurrentTeamInfo={this.setCurrentTeamInfo}
                              keyIdfr={EmailConfigTables.AuthorizedSendersTeam}
                              caption={"TEAMS"}
                              hideActionColumn={this.props.hideActionIcons}
                            />
                          </div>
                        </div>
                      )}
                    {this.props.hideActionIcons && (
                      <div className="row hidden delBtnTeams">
                        <div className="col-12 pt-3">
                          <button
                            type="button"
                            onClick={async () => {
                              await this.props.setAddtlSubsLoading(true);
                              await this.props.deleteAllAddlTeamListClick(
                                this.props.melstate.emailListId,
                                this.props.melstate.emailEntityType
                              );
                              await this.props.setAddtlSubsLoading(false);
                            }}
                            class="btn btn-danger"
                          >
                            Delete All Team Recipients{" "}
                            <i
                              className="fas fa-trash-alt cursorPointer"
                              aria-hidden="true"
                              title="Delete All Teams"
                            />
                          </button>
                        </div>
                      </div>
                    )}

                    <AuthorizedSendersModal
                      showModal={
                        this.props.melstate.openAssignAuthorizedSendersModal ||
                        this.props.melstate.openAssignAdditionalRecipientsModal
                      }
                      emailEntityType={this.props.emailEntityType}
                      emailListId={this.props.emailListId}
                    />
                    <MG_Add_NonNatca
                      handleClose={this.toggleAddNonNatcaModal}
                      showModal={this.state.isOpenAddNonNatcaModal}
                    />
                    <MG_ConfirmationModal
                      confirm={
                        this.state.teamModalOpended
                          ? this.confirmDeleteTeam
                          : this.confirmDeleteMember
                      }
                      modal={this.state.isConfirmModalOpen}
                      toggle={this.toggleConfirmDeleteModal}
                      userFirstName={this.state.userFirstName}
                      userLastName={this.state.userLastName}
                      teamName={this.state.team}
                      removeActionType={this.state.removeActionType}
                      teamModalOpended={this.state.teamModalOpended}
                      memberModalOpended={this.state.memberModalOpended}
                      confirmModelType={this.state.confirmModelType}
                    />
                    <MG_EditEmailAliasModal
                      show={this.state.showEmailAliasModal}
                      setMgListAlias={this.props.setMgListAlias}
                      handleEmailAliasChange={this.handleChange}
                      handleClose={this.toggleEmailAliasModal}
                      emailAlias={this.props.melstate.mgListAddressAlias}
                      domain={this.props.melstate.mgListDomain}
                      mailingListName={this.props.melstate.mailingListName}
                      changeHandlerListName={this.changeHandlerListName}
                    />
                    <MG_DeleteAllAuthSenders
                      modal={this.state.showEmailDeleteAllModal}
                      confirm={this.confirmDeleteAll}
                      toggle={this.toggleDeleteAllModal}
                      currentEmailConfigTab={currentEmailConfigTab}
                      onCancelClick={this.onCancelClick}
                    />
                    <MG_DeleteEmailList
                      modal={this.state.showDeleteEmailListModal}
                      confirm={this.confirmEmailList}
                      toggle={this.toggleDeleteEmailListModal}
                    />
                  </Fragment>
                }
              </Card.Body>
            </Card>
          </Tab>
          {/*#######################  Settings Tab END Here########################## */}
        </Tabs>
      </>
    );
  }
}
export default connect(
  (state) => ({
    melstate: state.mailGunEmail,
  }),
  {
    ...mailGunEmailActions,
  },
  null,
  { forwardRef: true }
)(MailGunConfigurationTabs);
